<template>
  <div class="home no-copy">
    <div>
      <div class="seach" >
        <div style="width: 90%; display: inline-block;">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="140px" size="mini">
            <el-row  type="flex" align="middle">
                <el-col :span="8" class="el-col-left"> 
                  <el-form-item label="Company Name">
                    <el-input v-model="formInline.companyName" placeholder="Company Name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left"> 
                  <el-form-item label="Accessory Category" >
                    <el-select v-model="formInline.accessoryCategoryId" placeholder="Accessory Category" filterable  clearable  :disabled="flag" >
                      <el-option
                        v-for="item in acData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Product Name">
                    <el-input v-model="formInline.productName" placeholder="Product Name" class="input-width"  :disabled="flag"></el-input>
                  </el-form-item>
                </el-col>
                
              </el-row>
              <el-row type="flex" align="middle">
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Technology">
                    <el-input v-model="formInline.technology" placeholder="Technology"   :disabled="flag"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Country">
                    <el-select v-model="formInline.countryId" placeholder="Country" filterable  clearable  :disabled="flag">
                        <el-option
                          v-for="item in countryData"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Region">
                    <el-select v-model="formInline.regionId" placeholder="Region" filterable clearable  :disabled="flag">
                      <el-option
                          v-for="item in regionData"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                
              </el-row>
              <el-row type="flex" align="middle">
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Model Name">
                    <el-input v-model="formInline.modelName" placeholder="Model Name"   :disabled="flag"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="Logo">
                    <el-select v-model="formInline.logoType" placeholder="Logo" filterable clearable :disabled="flag" >
                      <el-option label="TOP 甄选" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="el-col-left">
                  <el-form-item label="SN No. or 69 code">
                    <el-input v-model="formInline.code" placeholder="SN No. or 69 code"   :disabled="flag" class="input-width"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
        </div>
        <div style="width: 10%; display: inline-block;">
          <div style=""><el-button style="background-color: #1588f4; color: white;" @click="getList"  type="mini">Search</el-button></div>
          <div >
            <!--<span v-if="flag" style="font-size: 12px;">Click <a href="#" @click="toUlock" style="color: #1588f4;">"Unlock" </a> for more query conditions</span>-->
          </div>
        </div>
      </div>
      <div class="data">
        <el-table
          :data="tableData"
          height="500"
          border
          :header-cell-style="tableHeaderColor"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="NO"
            width="80"
            >
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="Company Name"
            sortable
            width="380">
          </el-table-column>
          
          <el-table-column
            prop="accessoryCategoryName"
            label="Accessory Category"
            sortable
            width="190">
          </el-table-column>
          <el-table-column
            prop="countryName"
            label="Country"
            sortable
            width="180">
          </el-table-column>
          <el-table-column
            prop="regionName"
            label="Region"
            sortable
            width="180"
            >
          </el-table-column>
          <el-table-column
            prop="companyWebsite"
            label="Company website"
            width="240">
          </el-table-column>
          <el-table-column
            prop="productName"
            label="Product Name"
            width="180">
          </el-table-column>
          <el-table-column
            prop="logoType"
            label="Logo"
            width="180"
            >
            <template #default="scope">
              <span v-if="scope.row.logoType == 0"> TOP 甄选</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="modelName"
            label="Model Name"
            width="180">
          </el-table-column>
          <el-table-column
            prop="technology"
            label="Technology"
            width="180">
          </el-table-column>
          <el-table-column
            prop="code"
            label="69 code"
            width="180">
          </el-table-column>
          <el-table-column
            prop="mfiProductSn"
            label="SN No. for MFI Product"
            width="180"
            >
          </el-table-column>
          
          <el-table-column
            prop="chipDeveloper"
            label="Chip Developer"
            width="180"
            >
          </el-table-column>
          <el-table-column
            prop="modularDeveloper"
            label="modular system-on-chip (SoC) developer"
            width="320"
            >
          </el-table-column>
          <el-table-column
            prop="finalAssembler"
            label="Final Assembler of ODM /OEM"
            width="280"
            >
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="text-align: right;margin-top: 10px;">
        <el-pagination
          :disabled="flag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage">
        </el-pagination>
      </div>
    </div>
    <div v-if="flag"  style="position: fixed; width: 100%; height: 60px;bottom: 15%; text-align: center;">
      <span style="font-size: 18px;font-weight: bold;"> Click <a href="#" @click="toUlock" style="color: #1588f4;">"Unlock" </a> to purchase a membership and unlock more query parameters and data</span>
    </div>
  </div>
</template>
<style>
.no-copy{
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}
  .custom-table-header th {
    background-color: #3937b4; /* 修改为你想要的颜色 */
  }
    .home{
    width: 98%;
    margin-left: 1%;
    
  }
  .el-col-left{
    text-align: left; 
    height: 45px;
  }
  .input-width{
    width: 194px;
  }
  .seach{
    margin-top: 10px;
    border: 1px solid rgb(235, 238, 245);
    margin-top: 10px;
    border-radius: 10px;
    padding: 10px;
  }
  .data{
    margin-top: 10px;
  }
</style>
<script>
export default {
  name: 'HomeView',
  data() {
      return {
        flag:true,
        currentPage4:1,
        formInline:{
          companyName:'',
          accessoryCategoryId:'',
          productName:'',
          modelName:'',
          technology:'',
          countryId:'',
          regionId:'',
          logoType:'',
          page:1,
          limit:20,
          code:''
        },
        tableData: [],
        acData:[],
        regionData:[],
        countryData:[],
        totalPage:0
      }
  },
  components: {
    
  },
  mounted(){
    this.refresh()
    this.getInit()
  },
  methods:{
    refresh(){
      let token = this.$cookie.get('token')
      if(token){  
          this.$http({url: this.$http.adornUrl('/app/isVa'),method: 'get'
          }).then(({data}) => {
            console.log(data)
            if (data && data.code === 0) {
              if(data.flag == 1){
                this.flag = false
              }
            } else {
              
              this.flag = true
            }
            this.getList()
          })
      }else{
        this.flag = true
        this.getList()
      }
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}){
      return 'background:	rgb(245,247,250); color:#000000;';
    },
    handleSizeChange(val){
      this.formInline.limit = val
      this.formInline.page = 1
      this.getList()
    },
    handleCurrentChange(val){
      this.formInline.page = val
      this.getList()
    },
    getInit(){
        this.$http({url: this.$http.adornUrl('/app/ac/getData'),method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.acData = data.data
          } else {
            
          }
        })

        this.$http({url: this.$http.adornUrl('/app/country/getData'),method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.countryData = data.data
          } else {
            
          }
        })

        this.$http({url: this.$http.adornUrl('/app/region/getData'),method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.regionData = data.data
          } else {
            
          }
        })
        

    },

    getList(){
      this.dataListLoading = true
        let url = this.flag? '/app/mfi/list2' :'/app/mfi/list';
        this.$http({
          url: this.$http.adornUrl(url),
          method: 'get',
          params: this.$http.adornParams(this.formInline)
        }).then(({data}) => {
          console.log(data)
          if (data && data.code === 0) {
            this.tableData = data.page.records
            this.totalPage = data.page.total
          } else {
            this.tableData = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
    },
    toUlock(){
      this.$router.push({ name: 'unlock'})
    }
    
  }
}
</script>
